import React from "react";

import { RoleExplanations } from "@/app/Views/StaticPages/HomePage/components/ViewJob/utils/helpers.ts";

import RoleAccordion from "./RoleExplainerAccordion";

interface RoleExplainerProps {
	roleExplanations?: RoleExplanations;
	lang?: "en" | "sw";
	onLangChange?: (lang: "en" | "sw") => void;
}

function RoleExplainer({ roleExplanations, lang, onLangChange }: RoleExplainerProps) {
	const enContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<p className="font-semibold">Summary</p>
				<p className="mt-1 text-sm">{roleExplanations.role_summary.en || "No summary for the role provided."}</p>

				<p className="font-semibold mt-3">Who it is</p>
				<p className="mt-1 text-sm">{roleExplanations.what_it_is.en || "No summary for what it is provided."}</p>

				<p className="font-semibold mt-3">Who Succeeds</p>
				<p className="mt-1 text-sm">{roleExplanations.who_succeeds.en || "No summary for who succeeds provided."}</p>

				{/* What You’ll Do */}
				<p className="font-semibold mt-3">What You’ll Do</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_will_do.en || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<p className="font-semibold mt-3">What You Need</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_need.en || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				{/* How to Apply */}
				<p className="font-semibold">How to Apply</p>
				<p className="mt-1 text-sm">
					{roleExplanations?.how_to_apply?.instructions.en || "No application instructions provided."}
				</p>

				<p className="font-semibold mt-3">Include:</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations?.how_to_apply?.include.en || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				<p className="text-sm">
					<a href="#">Fit check me</a> and We will tell you how well you match the role.
				</p>
			</>
		) : (
			<p className="mt-1 text-sm">No role explainer for this job.</p>
		);

	const swContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<p className="font-semibold">Muhtasari</p>
				<p className="mt-1 text-sm">{roleExplanations.role_summary.sw || "Hakuna muhtasari uliotolewa."}</p>

				<p className="font-semibold mt-3">Dhana Yake</p>
				<p className="mt-1 text-sm">{roleExplanations.what_it_is.sw || "Hakuna muhtasari uliotolewa."}</p>

				<p className="font-semibold mt-3">Wanaofanikiwa kwa kawaida</p>
				<p className="mt-1 text-sm">{roleExplanations.who_succeeds.sw || "Hakuna muhtasari uliotolewa."}</p>

				{/* What You’ll Do */}
				<p className="font-semibold mt-3">Majukumu yako</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_will_do.sw || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<p className="font-semibold mt-3">Unachohitaji</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations.what_you_need.sw || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				{/* How to Apply */}
				<p className="font-semibold">Namna ya Kutuma Maombi</p>
				<p className="mt-1 text-sm">
					{roleExplanations?.how_to_apply?.instructions.sw || "Hakuna maelekezo ya kuomba yaliyotolewa."}
				</p>

				<p className="font-semibold mt-3">Jumuisha:</p>
				<ul className="list-disc pl-4 text-sm space-y-1">
					{(roleExplanations?.how_to_apply?.include.sw || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-2 mt-2" />

				<p className="text-sm">
					<a href="#">Tathmini ulinganifu wako</a> nasi tutakuambia jinsi ufaavyo kwa kazi hii.
				</p>
			</>
		) : (
			<p className="mt-1 text-sm">Hakuna maelezo ya majukumu ya kazi hii.</p>
		);

	return (
		<RoleAccordion
			title="Role Explainer"
			content={{
				en: enContent,
				sw: swContent,
			}}
			lang={lang}
			onLangChange={onLangChange}
		/>
	);
}

export default RoleExplainer;
